import { render, staticRenderFns } from "./UpdatePhoneVerification.vue?vue&type=template&id=623f6952&scoped=true&"
import script from "./UpdatePhoneVerification.vue?vue&type=script&lang=ts&"
export * from "./UpdatePhoneVerification.vue?vue&type=script&lang=ts&"
import style0 from "./UpdatePhoneVerification.vue?vue&type=style&index=0&id=623f6952&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "623f6952",
  null
  
)

export default component.exports